export const ListDuration = {
  ONE_HALF: {
    title: 'excursions.one_half',
    key: 'ONE_HALF',
  },
  TWO_HOURS: {
    title: 'excursions.two_hours',
    key: 'TWO_HOURS',
  },
  ONE: {
    title: 'excursions.one_day',
    key: 'ONE',
  },
  TWO: {
    title: 'excursions.two_day',
    key: 'TWO',
  },
  THREE_AND_MORE: {
    title: 'excursions.more_day',
    key: 'THREE_AND_MORE',
  },
}

export const DurationList = Object.keys(ListDuration)?.map((key) => ({
  title: ListDuration[key as keyof typeof ListDuration].title,
  key: key,
}))

export type DurationTypes = keyof typeof ListDuration

export const ListDifficult = {
  EASY: {
    title: 'excursions.easy',
    key: 'EASY',
  },
  MEDIUM: {
    title: 'excursions.medium',
    key: 'MEDIUM',
  },
  HARD: {
    title: 'excursions.hard',
    key: 'HARD',
  },
}

export const DifficultList = Object.keys(ListDifficult)?.map((key) => ({
  title: ListDifficult[key as keyof typeof ListDifficult].title,
  key: key,
}))

export type DifficultTypes = keyof typeof ListDifficult
